import styled from 'styled-components';
import { media } from '~/styles';
import { SIDEBAR_WIDTH } from '../../constants';

export const Wrapper = styled.div`
  display: flex;
  ${media.mobile} {
    flex-direction: column;
    height: 100vh;
  }
`;

export const Aside = styled.aside`
  flex: 0 0 ${SIDEBAR_WIDTH}px;
  max-width: ${SIDEBAR_WIDTH}px;
  position: sticky;
  top: 0;
  box-sizing: border-box;
  border-right: 1px solid ${({ theme }) => theme.colors.on[100]};
  height: 100vh;
  z-index: 1;
`;
export const MobilePadding = styled.div`
  min-height: ${({ theme }) => theme.spacing(10)}px;
  width: 100%;
  display: none;
  ${media.mobile} {
    display: block;
  }
`;

export const Body = styled.div`
  flex: 1 1 auto;
  height: auto;
  overflow: auto;
  position: relative;
  z-index: 1;
`;

export const PositionWrapper = styled.div`
  position: relative;
  z-index: 0;
`;
